import { Box } from '@mui/material';
import PowerBIReport from 'components/featured/Reports/PowerBIReport';

const ReportsPage = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 'calc(100vh - 70px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        p: 0
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          width: '100%',
          '& iframe': {
            width: '100%',
            height: '100%',
            border: 'none'
          }
        }}
      >
        <PowerBIReport
          reportName="Report 1 - Client, Lead, Deal"
          loadingText="Loading Power BI Report..."
        />
      </Box>
    </Box>
  );
};

export default ReportsPage;